export const QR_PAYLOAD_PATTERN = /^qr_[a-zA-Z0-9-_]+$/;
const QR_PAYLOAD_EXTRACT_PATTERN = /qr_[a-zA-Z0-9-_]+/;

export function normalizeQrPayloadInput(rawInput: string): string {
  return rawInput.trim();
}

export function validateQrPayload(payload: string): boolean {
  return QR_PAYLOAD_PATTERN.test(normalizeQrPayloadInput(payload));
}

export function extractQrPayload(rawInput: string): string | null {
  const normalized = normalizeQrPayloadInput(rawInput);
  if (!normalized) {
    return null;
  }

  const decoded = (() => {
    try {
      return decodeURIComponent(normalized);
    } catch {
      return normalized;
    }
  })();

  if (validateQrPayload(decoded)) {
    return decoded;
  }

  const match = decoded.match(QR_PAYLOAD_EXTRACT_PATTERN);
  if (!match) {
    return null;
  }

  return validateQrPayload(match[0]) ? match[0] : null;
}

export function qrScanErrorToMessage(error: unknown): string {
  if (
    error &&
    typeof error === "object" &&
    "name" in error &&
    typeof error.name === "string"
  ) {
    if (error.name === "NotAllowedError") {
      return "Нет доступа к камере. Разрешите доступ в браузере.";
    }
    if (error.name === "NotFoundError") {
      return "Камера не найдена на устройстве.";
    }
    if (error.name === "NotReadableError") {
      return "Камера занята другим приложением.";
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return "Ошибка сканирования QR-кода";
}
